// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"22":"93ba7fbf","119":"54e56a00","212":"102ead27","235":"48ba4445","355":"aad96220","775":"d4a48f17","937":"c5325f39"}[chunkId] + ".js";
};